import { render, staticRenderFns } from "./CorporationAccount.vue?vue&type=template&id=9614bcbe&scoped=true&"
import script from "./CorporationAccount.vue?vue&type=script&lang=js&"
export * from "./CorporationAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9614bcbe",
  null
  
)

export default component.exports